export class QualificationCardModule {
  id: string = ''
  name: string = ''
  description: string = ''
  studyDuration: string = ''
  studyPrice: string = ''
  theme: string = 'default'
  image: string = ''
}
